export default {
  className: '_User',
  render: (residentialQuarters) => {
    return `${residentialQuarters.name}`
  },
  fields: [
    {
      name: 'nickName',
      validators: [
        (val) => val ? null : '昵称不可为空'
      ]
    },
    {
      name: 'username',
      note: '用户名',
      tooltip: '初始密码为：123456',
      validators: [
        (val) => val ? null : '用户名不可为空',
        (val) => {
          let reg = /^[a-zA-Z]*$/g
          return reg.test(val) ? null : '用户名格式不正确'
        }
      ]
    }
  ],
  search: [
    'nickName'
  ],
  hooks: {
    beforeInsert ({ data }) {
      data.password = '123456'
      data.isAdmin = true
    },
    beforeFetch ({ where }) {
      where.isAdmin = true
    }
  },
  action: {
    reset: {
      text: '重置密码',
      type: 'row',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '你确定要重置密码吗?')
        let rs = await vm.$modelAjax.put(modelName, record.objectId, {
          password: '123456'
        }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '重置密码失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '密码已被重置为123456'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
      }
    }

  }
}
